var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"description",staticClass:"textarea textarea-block font-size-16 md:font-size-20",domProps:{"value":_vm.value},on:{"input":_vm.input,"blur":_vm.blur}})
}
var staticRenderFns = []

export { render, staticRenderFns }